import { connect } from 'react-redux';
import { openManaFiatGatewayRequest } from '../../modules/gateway/actions';
import { getError, isFinishingPurchase, isOpeningGateway } from '../../modules/gateway/selectors';
import { isEnabled } from '../../modules/translation/selectors';
import BuyManaWithFiatModal from './BuyManaWithFiatModal';
const mapState = (state) => ({
    hasError: !!getError(state),
    isLoading: isOpeningGateway(state) || isFinishingPurchase(state),
    hasTranslations: isEnabled(state)
});
const mapDispatch = (dispatch) => ({
    onContinue: (network, gateway) => dispatch(openManaFiatGatewayRequest(network, gateway))
});
export default connect(mapState, mapDispatch)(BuyManaWithFiatModal);
//# sourceMappingURL=BuyManaWithFiatModal.container.js.map